/**
 * Kappa Italy megamenu — L2 hover switches L3 pane.
 * defer; custom element reconnects on shopify:section:load.
 */
(function () {
  if (customElements.get('lop-mega-menu')) return;

  class LopMegaMenu extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.buttons = this.querySelectorAll('[data-lop-mega-target]');
      this.panes = this.querySelectorAll('[data-lop-mega-pane]');
      this.onEnter = (event) => this.activate(event.currentTarget);
      this.onClick = (event) => {
        if (event.currentTarget.tagName === 'BUTTON') {
          event.preventDefault();
        }
      };
      this.buttons.forEach((button) => {
        button.addEventListener('mouseenter', this.onEnter);
        button.addEventListener('focus', this.onEnter);
        button.addEventListener('click', this.onClick);
      });
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      if (!this.buttons || !this.onEnter) return;
      this.buttons.forEach((button) => {
        button.removeEventListener('mouseenter', this.onEnter);
        button.removeEventListener('focus', this.onEnter);
        if (this.onClick) button.removeEventListener('click', this.onClick);
      });
    }

    activate(button) {
      const id = button.getAttribute('data-lop-mega-target');
      this.buttons.forEach((item) => {
        item.classList.toggle('is-active', item === button);
      });
      this.panes.forEach((pane) => {
        pane.classList.toggle('is-active', pane.getAttribute('data-lop-mega-pane') === id);
      });
    }
  }

  customElements.define('lop-mega-menu', LopMegaMenu);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('lop-mega-menu').forEach(function (el) {
      if (typeof el.connectedCallback === 'function') {
        el.connectedCallback();
      }
    });
  });
})();
